export function getBaseUrl() {
  const addHttpsIfNeeded = (url: string | undefined) => {
    if (!url) return "";
    return url.startsWith("http") ? url : `https://${url}`;
  };

  if (process.env.NODE_ENV === "production") {
    return addHttpsIfNeeded(process.env.NEXT_PUBLIC_SITE_URL || process.env.SITE_URL);
  }

  // TODO: add preview url
  return addHttpsIfNeeded(process.env.NEXT_PUBLIC_SITE_URL || process.env.SITE_URL);
}
